export const applicantDetailsRoute = '/employer/applicants/details/';
export const downloadResumeRoute = 'applicants/resume/download/';
export const downloadEmployerResumeRoute = 'employer/resume/download/';
export const downloadEnterpriseResumeRoute = 'enterprise/resume/download/';
export const applicantReferencesRoute = '/references/get/';
export const deleteApplicantReferencesRoute = '/references/delete/';
export const postApplicantReferencesRoute = '/references/create/';
export const getJobNearMeRoute = '/applicants/search/nearme/';
export const updateApplicantProfilePictureRoute = '/applicants/profile-pic/';
export const withdrawApplicationRoute = '/applicants/applications/withdraw/';
export const responseJobOfferRoute = '/applicants/joboffers/respond/';
export const invitationInviteReplyRoute = '/applicants/calendar/invitation/';
export const postApplicantCertificationRoute =
  '/applicants/resume/certification/';
export const postApplicantSkillsRoute = '/applicants/resume/skills/';
export const deleteApplicantCertificationRoute =
  '/applicants/resume/certification/delete/';
export const deleteApplicantSkillsRoute = '/applicants/resume/skills/delete/';
export const deleteWorkHistoryRoute = '/applicants/resume/work-history/delete/';
export const postWorkHistoryRoute = '/applicants/resume/work-history/';
export const postEducationRoute = '/applicants/resume/education/';
export const deleteEducationRoute = '/applicants/resume/education/delete/';
export const deleteResumeRoute = '/applicants/resume/delete/';
export const uploadResumeRoute = '/applicants/resume/upload/';
export const downloaddResumeRoute = 'applicants/download/resume';
export const avaliableBlocksRoute = 'applicants/calendar/blocks/available/';
export const avaliableBookedBlocksRoute = 'applicants/calendar/block/scheduled/get/';
export const applicantSignupPostionRoute = 'applicants/profile/signup-position/set/';
export const getCompanyAndJobPostingRote = 'employer/job-posting/';
export const signupBlocksRoute = 'applicants/calendar/block/signup/';
export const signupUpdateBlocksRoute = 'applicants/calendar/block/signup/update/';
export const deactivatAccountRoute = 'applicants/account/deactivate/';
export const reactivatAccountRoute = 'applicants/account/reactivate/';
export const createApplicationHistoryRoute = 'applicants/application-history/';
export const completeWalkthroughRoute = '/walkthrough/complete/';
